import React from 'react';
import {
    HomeFilled,
    HomeOutlined,
    WalletFilled,
    WalletOutlined,
    NotiOutlined,
    NotiFilled,
    ProfileOutlined,
    ProfileFilled,
    SpinFilled,
} from '@assets';
import {
    Container,
    ItemWrapper,
    Label,
} from './BottomNavigator.style';
import { useLocation, useNavigate } from 'react-router-dom';
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from '@router/route.constants';
import { useTranslation } from "react-i18next";
import { localStorage } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenLoginAlert } from "@redux/auth/authSlice";

const Item = ({
    path,
    label,
    icon,
    icon_active,
    is_home,
    is_private,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const is_active = pathname.includes(path);
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();
    const isLoggedIn = useSelector((state) => state.auth.token);

    const checkIsLoggedIn = () => {
        if (!isLoggedIn) {
            dispatch(setOpenLoginAlert(true));
        }
        return isLoggedIn;
    };

    const handleClicked = (path, is_home) => {
        if (is_private && !checkIsLoggedIn()) {
            return;
        }
        const _path = is_home ? path : `/${path}`;
        navigate(_path, { replace: true });
    }

    return (
        <ItemWrapper
            status={is_active ? 'active' : 'default'}
            onClick={() => handleClicked(path, is_home)}
        >
            {is_active ? icon_active : icon}
            <Label lang={userPreferedLanguage}>
                {label}
            </Label>
        </ItemWrapper>
    );
}

const BottomNavigator = () => {
    const { t } = useTranslation()
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();

    const options = [
        {
            path: PUBLIC_ROUTE.GAMES,
            label: t("bottomNavigator.home"),
            icon: <HomeOutlined />,
            icon_active: <HomeFilled />,
            is_home: true,
            is_private: false,
        },
        {
            path: PRIVATE_ROUTE.WALLET,
            label: t("bottomNavigator.wallet"),
            icon: <WalletOutlined />,
            icon_active: <WalletFilled />,
            is_home: true,
            is_private: true,
        },
        {
            path: PUBLIC_ROUTE.SPIN_HOME,
            icon: <SpinFilled id='spinwheel' />,
            is_home: false,
            is_private: false,
        },
        {
            path: PUBLIC_ROUTE.NOTIFICATION,
            label: t("bottomNavigator.notification"),
            icon: <NotiOutlined />,
            icon_active: <NotiFilled />,
            is_home: true,
            is_private: false,
        },
        {
            path: PUBLIC_ROUTE.PROFILE,
            label: t("bottomNavigator.profile"),
            icon: <ProfileOutlined />,
            icon_active: <ProfileFilled />,
            is_home: true,
            is_private: false,
        },
    ];

    return (
        <Container lang={userPreferedLanguage}>
            {options.map((item, key) => (
                <Item
                    key={key}
                    path={item.path}
                    label={item.label}
                    icon={item.icon}
                    icon_active={item.icon_active}
                    is_home={item.is_home}
                    is_private={item.is_private}
                />
            ))}
        </Container>
    );
}

export default BottomNavigator;